import React from 'react';
import { useLanguage } from '../LanguageContext';
import { t } from '../translations';
import ManageSubscriptionButton from './ManageSubscriptionButton';

const Header = ({ view, handleLogout, userProfile }) => {
  const { language, setLanguage, languages } = useLanguage();
  const isHomeView = view === 'home' || view === 'topics';

  return (
    /* FIX: max-w-full och overflow-hidden för att stoppa sidscroll */
    <header className="w-full max-w-full overflow-hidden box-border bg-white md:bg-transparent border-b md:border-none border-slate-200 sticky top-0 z-40 h-16 flex items-center justify-between px-4 md:px-8">
      
      {/* Vänster sida: Logga */}
      <div className="flex items-center md:hidden min-w-0 flex-1">
        <span className="text-xl mr-2 shrink-0">🔬</span>
        <span className="font-serif font-bold text-base text-slate-800 italic truncate">
          Science Monitor
        </span>
      </div>

      {/* Höger sida: Prenumeration, Språkväljare och Logga ut */}
      <div className="md:hidden flex items-center shrink-0 ml-2 gap-2">
        
        {/* Prenumerationshanterare för mobil (visas enbart för betalande konton) */}
        <ManageSubscriptionButton userProfile={userProfile} compact />

        {/* Visar endast språkväljaren på hem/sök-vyerna */}
        {isHomeView && (
          <div className="flex items-center bg-slate-100 border border-slate-200 rounded-full px-2 py-1 shadow-sm">
            <span className="text-sm mr-1">🌍</span>
            <select 
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="bg-transparent text-[10px] font-bold text-slate-700 outline-none cursor-pointer appearance-none uppercase"
            >
              {languages?.map(lang => (
                <option key={lang} value={lang}>
                  {lang === 'Svenska' ? 'SV' : lang === 'Engelska' ? 'EN' : lang.substring(0, 2).toUpperCase()}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Utloggningsknapp - visas alltid */}
        <button 
          onClick={handleLogout}
          className="flex items-center justify-center p-1.5 text-slate-500 hover:text-red-600 bg-slate-50 hover:bg-red-50 rounded-full border border-slate-200 transition-colors shadow-sm active:scale-95"
          title={t(language, 'menu_logout')}
        >
          <span className="text-sm">🚪</span>
        </button>
      </div>

      <div className="hidden md:block"></div>
    </header>
  );
};

export default Header;